const getCSSVariable = (variableName) => {
    return getComputedStyle(document.documentElement).getPropertyValue(variableName).trim();
};

export function generateOption2HTML(data) {
    const {
        image,
        title,
        author_name,
        category,
        date,
        html,
        imgText
    } = data;

    const marginLeft = getCSSVariable('--marginLeftDefault')
    const marginRight = getCSSVariable('--marginRightDefault')
    return `
    <style>
    /* General Layout */

    .contentSection{
     margin: 60px ${marginRight} 0px ${marginLeft};
        height: 100%;
    }


    .text-content {
    width: 100%;
    }

    .contentImg{
        width: 100%;
        height: auto;
    }

    /* Text Block */
    .text-title {
        font-size: 30px;
        margin:0px 0px 5px 0px;
    }

    .text-meta {
        display: flex;
        justify-content: space-between;
        margin-bottom: 0px;
        flex-wrap: wrap;
        /* Allow wrapping of text content */
    }

    .text-meta p {
        margin: 0;
    }
    .cat {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }

    /* Media Query for Small Screens */
    @media screen and (max-width: 900px) {

        .text-paragraph {
            margin-top: 10px;
        }
    }

    @media screen and (max-width: 500px) {
        .cat {
            width: 100%;
            /* Force the second paragraph to take the full width */
            /* Optional: Add some space between the lines */
            order: 3;
            margin-top:10px;
        }

        /* Make sure Kai Starke and 13. Apr 2025 stay together in the same row */
        .text-meta {
            flex-direction: row;
            /* Ensure that they are in a row even on small screens */
            justify-content: space-between;
            align-items: center;
        }
    }
</style>

<div class="contentSection">
<img class="contentImg" src='${image}' alt="${imgText}" />
    <div class="text-content">
        <h1 class="text-title">${title}</h1>
        <div class="text-meta">
            <p>${author_name}</p>
            <p>${category}</p>
            <p>${new Date(date).toLocaleDateString('de-DE', {
        day: '2-digit', month: 'short', year: 'numeric'
    })}</p>
        </div>
    </div>
    <div class="text-paragraph">${html}</div>
</div>
`;
}
